import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { FormFeedback } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePicker.css";

import { format, parseISO } from "date-fns";

export default class DatePickerInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: "",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    console.log("THIS: ", date);
    this.setState({
      date: date,
    });
    console.log(this.props.input, "[[[[INPUTTTTT");
    this.props.input.onChange(date.set({ h: 12, m: 0 }));
  }

  render() {
    const selected = this.props.input.value
      ? new Date(this.props.input.value)
      : null;
    // const selected = new Date();
    console.log(this.props.input.value, "this.props.input.value");
    console.log(selected, "SELECTED VALUE");
    return (
      <div>
        <DatePicker
          selected={selected}
          showYearDropdown
          className={
            this.props.meta.touched && this.props.meta.error
              ? "is-invalid form-control"
              : "form-control"
          }
          placeholderText={this.props.placeholder}
          onChange={this.handleChange}
          monthsShown={this.props.monthsShown}
          {...this.props}
        />
        {this.props.meta.touched && this.props.meta.error && (
          <FormFeedback style={{ display: "block" }}>
            {this.props.meta.error}
          </FormFeedback>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/system/fields/DatePickerOld/index.jsx